import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.find.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { FAQ, PRIVACY_POLICY, LEGAL_NOTICE, CGU } from '~/const/faq';
import USE_MARKETPLACE from '~/const/marketplace';

var MdmModal = function MdmModal() {
  return import(
  /* webpackChunkName: "modal" */
  '~/components/atoms/Global/MdmModal.vue');
};

export default {
  name: 'Mentions',
  components: {
    MdmModal: MdmModal
  },
  data: function data() {
    return {
      showModal: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    getDate: function getDate() {
      var d = new Date();
      return d.getFullYear();
    },
    setLocale: function setLocale() {
      return "".concat(this.locale.market, "/").concat(this.locale.language);
    },
    helpAndFaqsLinks: function helpAndFaqsLinks() {
      var _this = this;

      return FAQ.find(function (faq) {
        return faq.language === _this.locale.iso;
      }).url;
    },
    legalNoticeLinks: function legalNoticeLinks() {
      var _this2 = this;

      return LEGAL_NOTICE.find(function (legalNotice) {
        return legalNotice.language === _this2.locale.iso;
      }).url;
    },
    privacyPolicyLinks: function privacyPolicyLinks() {
      var _this3 = this;

      return PRIVACY_POLICY.find(function (privacyPolicy) {
        return privacyPolicy.language === _this3.locale.iso;
      }).url;
    },
    cguLinks: function cguLinks() {
      var _this4 = this;

      return CGU.find(function (cgu) {
        return cgu.language === _this4.locale.iso;
      }).links;
    },
    isMarketplaceOpen: function isMarketplaceOpen() {
      return USE_MARKETPLACE(this);
    }
  }),
  methods: {
    editCookies: function editCookies() {
      if (window.tC && window.tC.privacyCenter) {
        window.tC.privacyCenter.showPrivacyCenter();
      }

      return false;
    }
  }
};